import * as React from 'react';

import {CTABanner} from 'shells/cta-banner/cta-banner';
// @ts-expect-error - imported from .js/.jsx file
import {CampaignIcon} from 'shells/icon/svg/campaign-icon';

import styles from './banner.module.css';

type Props = {
    width: number;
};

export function NutshellEmailMarketingCtaBanner(props: Props) {
    return (
        <div style={{width: props.width}} className={styles['banner-container']}>
            <CTABanner
                icon={CampaignIcon}
                title='Automate your email outreach'
                text='Create and share a personal email sequence to automatically send to your leads.'
                buttonText='Get started'
                maxWidth={null}
                href='/email/templates#/templates/new'
                newTab={true}
            />
        </div>
    );
}
